import {
  ADD_QUESTION,
  EDIT_QUESTION, EDIT_QUESTION_IMAGE, ENABLE_QUESTION, GET_QUESTION,
  GET_QUESTIONS, QUESTION_FAILURE,
  QUESTION_LOADING, QUESTION_LOADING_ANSWERS,
  REMOVE_QUESTION
} from '../actions/questionActions';

const initialState = {
  items: {},
  loading: false,
  loadingAnswers: false,
  error: null,
};

const questions = (currentState = initialState, action) => {
  let newState;
  switch (action.type) {
    case QUESTION_LOADING:
      newState = {
        ...currentState,
        loading: true,
      };
      return newState;
    case QUESTION_LOADING_ANSWERS:
      newState = {
        ...currentState,
        loadingAnswers: true,
      };
      return newState;
    case QUESTION_FAILURE:
      newState = {
        ...currentState,
        loading: false,
        error: action.error,
      };
      return newState;
    case GET_QUESTIONS:
      newState = {
        ...currentState,
        items: {
          ...currentState.items,
        },
        loading: false,
      };
      if (action.questions && action.questions.length) {
        action.questions.forEach((question) => {
          newState.items[question.id] = {
            ...question,
          }
        });
      }
      return newState;
    case GET_QUESTION:
      newState = {
        ...currentState,
        items: {
          ...currentState.items,
          [action.question.id]: {
            ...currentState.items[action.question.id],
            ...action.question,
            answers: action.answers,
          }
        },
        loading: false,
        loadingAnswers: false
      };
      return newState;
    case ADD_QUESTION:
      newState = {
        ...currentState,
        items: {
          ...currentState.items,
          [action.question.id]: {
            ...action.question,
            answers: action.answers,
          },
        },
        loading: false,
      };
      return newState;
    case EDIT_QUESTION:
      newState = {
        ...currentState,
        items: {
          ...currentState.items,
          [action.question.id]: {
            ...currentState.items[action.question.id],
            ...action.question,
            answers: action.answers,
          },
        },
        loading: false,
      };
      return newState;
    case REMOVE_QUESTION:
      newState = {
        ...currentState,
        items: {
          ...currentState.items,
        },
        loading: false,
      };
      if (newState.items[action.questionId]) delete newState.items[action.questionId];
      return newState;
    case ENABLE_QUESTION:
      newState = {
        ...currentState,
        items: {
          ...currentState.items,
          [action.questionId]: {
            ...currentState.items[action.questionId],
            enabled: !currentState.items[action.questionId].enabled
          }
        },
        loading: false,
      };
      return newState;
    case EDIT_QUESTION_IMAGE:
      newState = {
        ...currentState,
        items: {
          ...currentState.items,
          [action.question.id]: {
            ...currentState.items[action.question.id],
            ...action.question,
          }
        },
        loading: false
      };
      return newState;
    default:
      return currentState;
  }
};

export default questions;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/questionsReducer.js
 **/